import { postAiEvent } from './aiService';

export const AI_UI_EVENT_TYPES = {
  LAUNCHER_OPENED: 'AI_UI_LAUNCHER_OPENED',
  MESSAGE_SENT: 'AI_UI_MESSAGE_SENT',
  REFUSAL_SHOWN: 'AI_UI_REFUSAL_SHOWN',
  PROPOSAL_SHOWN: 'AI_UI_PROPOSAL_SHOWN',
  PROPOSAL_CONFIRMED: 'AI_UI_PROPOSAL_CONFIRMED',
  PROPOSAL_CANCELED: 'AI_UI_PROPOSAL_CANCELED',
  HANDOFF_OPENED: 'AI_UI_HANDOFF_OPENED',
  SESSION_CLEARED: 'AI_UI_SESSION_CLEARED',
};

const sanitizeValue = (value) => {
  const normalized = String(value || '').trim();
  return normalized || undefined;
};

export const trackAiEvent = async ({
  type,
  role,
  routeKey,
  capabilityKey,
  actionId,
  handoffRouteKey,
  resultKind,
  metadata,
} = {}) => {
  if (!sanitizeValue(type) || !sanitizeValue(role)) {
    return;
  }

  try {
    await postAiEvent({
      type: sanitizeValue(type),
      role: sanitizeValue(role),
      routeKey: sanitizeValue(routeKey),
      capabilityKey: sanitizeValue(capabilityKey),
      actionId: sanitizeValue(actionId),
      handoffRouteKey: sanitizeValue(handoffRouteKey),
      resultKind: sanitizeValue(resultKind),
      metadata: metadata && typeof metadata === 'object' ? metadata : undefined,
    });
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('AI analytics event failed', error?.message || error);
    }
  }
};
